angular.module('shared').factory('SelectAllPagesService', ["$modal", function($modal) {
  return {
    confirmDeselect: function(params) {
      var modalInstance;
      modalInstance = $modal.open({
        template: require('templates/shared/select_all_pages_confirm_deselect.html.slim'),
        resolve: {
          params: function() {
            return params;
          }
        },
        controller: ["$scope", "$modalInstance", "params", function($scope, $modalInstance, params) {
          $scope.name = params.name;
          $scope.submit = function() {
            return $modalInstance.close();
          };
          return $scope.cancel = function() {
            return $modalInstance.dismiss('cancel');
          };
        }]
      });
      return modalInstance.result;
    }
  };
}]);
